import React from "react";
import PropTypes from "prop-types";
import PrimaryButton from "components/v3/primary-button/PrimaryButton";
import { BUTTON_THEME_WHITE_LIGHT_FOCUS } from "components/v3/primary-button/themes";
import { SOCIAL_MEDIA, BLOOMBERG_EMAIL_REGEX } from "common/constants/Constants";
import styles from "./styles.module.scss";

const TerminalLoginAlert = ({ email = "", onClick }) => {
    if (!BLOOMBERG_EMAIL_REGEX.test(email)) {
        return null;
    }

    const onTerminalClick = () => onClick(SOCIAL_MEDIA.TERMINAL);

    return (
        <div className={ styles.alert }>
            <span className={ styles.message }>Bloomberg Anywhere clients get free access to Bloomberg.com</span>
            <div className={ styles.button }>
                <PrimaryButton onClick={ onTerminalClick } theme={ BUTTON_THEME_WHITE_LIGHT_FOCUS } text="BBA Clients Log In Here" type="button" />
            </div>
        </div>
    );
};

TerminalLoginAlert.propTypes = {
    email: PropTypes.string,
    onClick: PropTypes.func.isRequired
};

export default TerminalLoginAlert;
